import { COLOR_SCHEMES } from '../constants/tmuaColorSchemes';

/**
 * The colour scheme the IVORI simulator draws with.
 *
 * `tmuaColorSchemes.js` keeps the `ivori` entry literal because the Pearson
 * pre-screens draw #000 on it. The simulator maps that entry to tokens so it
 * follows light and dark mode; the Pearson schemes stay literal.
 */
export const getSimScheme = (colorScheme) => (colorScheme === 'ivori'
  ? { ...COLOR_SCHEMES.ivori, chrome: 'var(--iv-panel)', body: 'var(--iv-bg)', border: 'var(--iv-line)', text: 'var(--iv-head)' }
  : COLOR_SCHEMES[colorScheme]);

/** Text on a scheme background: the token on ivori, the scheme's own ink on a Pearson scheme. */
export const simInk = (colorScheme, scheme, token) => (colorScheme === 'ivori' ? token : scheme.text);

/** The same, where the background is the scheme's only for a TMUA sitting. */
export const tmuaInk = (isTmuaExam, colorScheme, scheme, token) => (
  isTmuaExam && colorScheme !== 'ivori' ? scheme.text : token
);

/** The red of a warning mark: the danger token on ivori, Pearson's red on a Pearson scheme. */
export const simDanger = (colorScheme) => (colorScheme === 'ivori' ? 'var(--iv-danger)' : '#D92D20');
